import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import Sections from "./site/Sections";
import Fields from "./site/Fields";
import Labels from "./site/Labels";
import SectionPage from "./site/Section";

import Utils from "../../../Utils";
import SiteReportsPage from "./site/SiteReportsPage";
import LinksPage from "./site/links/LinksPage";
import ScoreRange from "./site/range/ScoreRange";

function SiteDefaultPage() {
    let [canRender, setCanRender] = useState(false);

    useEffect(() => {
        setCanRender(true);
    }, []);

    let sectionsPath = Utils.APP_URLS.SITE_SECTIONS.replace(
        Utils.APP_URLS.SITE_PAGE,
        "",
    );

    let projectSectionsPath = Utils.APP_URLS.PROJECT_SITE_SECTIONS.replace(
        Utils.APP_URLS.PROJECT_SITE_PAGE,
        "",
    );

    let sectionPath = Utils.APP_URLS.SECTION_PAGE.replace(
        Utils.APP_URLS.SITE_PAGE,
        "",
    );

    let projectSectionPath = Utils.APP_URLS.PROJECT_SECTION_PAGE.replace(
        Utils.APP_URLS.PROJECT_SITE_PAGE,
        "",
    );


    let fieldsPath = Utils.APP_URLS.SITE_FIELDS.replace(
        Utils.APP_URLS.SITE_PAGE,
        "",
    );

    let projectFieldsPath = Utils.APP_URLS.PROJECT_SITE_FIELDS.replace(
        Utils.APP_URLS.PROJECT_SITE_PAGE,
        "",
    );

    let labelsPath = Utils.APP_URLS.SITE_LABELS.replace(
        Utils.APP_URLS.SITE_PAGE,
        "",
    );

    let projectLabelsPath = Utils.APP_URLS.PROJECT_SITE_LABELS.replace(
        Utils.APP_URLS.PROJECT_SITE_PAGE,
        "",
    );

    let reportsPath = Utils.APP_URLS.SITE_REPORTS.replace(
        Utils.APP_URLS.SITE_PAGE,
        "",
    );

    let projectReportsPath = Utils.APP_URLS.PROJECT_SITE_REPORTS.replace(
        Utils.APP_URLS.PROJECT_SITE_PAGE,
        "",
    );

    let linksPath = Utils.APP_URLS.SITE_LINKS.replace(
        Utils.APP_URLS.SITE_PAGE,
        "",
    );

    let projectLinksPath = Utils.APP_URLS.PROJECT_SITE_LINKS.replace(
        Utils.APP_URLS.PROJECT_SITE_PAGE,
        "",
    );

    let projectRangePath = Utils.APP_URLS.PROJECT_SITE_RANGE.replace(
        Utils.APP_URLS.PROJECT_SITE_PAGE,
        "",
    );

    return (
        <>
            {canRender && (
                <Routes>
                    <Route path={`/`} exact element={<Sections />}></Route>

                    {/* <Route
                        path={sectionPath}
                        exact
                        element={<SectionPage />}
                    ></Route> */}
                    <Route
                        path={projectSectionPath}
                        exact
                        element={<SectionPage />}
                    ></Route>
                    {/* <Route
                        path={sectionsPath}
                        element={<Sections />}
                    ></Route> */}
                    <Route
                        path={projectSectionsPath}
                        element={<Sections />}
                    ></Route>
                    {/* <Route
                        path={fieldsPath}
                        element={<Fields />}
                    ></Route> */}
                    <Route
                        path={projectFieldsPath}
                        element={<Fields />}
                    ></Route>
                    {/* <Route
                        path={labelsPath}
                        element={<Labels />}
                    ></Route> */}
                    <Route
                        path={projectLinksPath}
                        element={<LinksPage />}
                    ></Route>
                    <Route
                        path={projectLabelsPath}
                        element={<Labels />}
                    ></Route>
                    {/* <Route
                        path={reportsPath}
                        element={<SiteReportsPage />}
                    >
                    </Route> */}
                    <Route
                        path={projectReportsPath}
                        element={<SiteReportsPage />}
                    >
                    </Route>
                    <Route
                        path={projectRangePath}
                        element={<ScoreRange />}
                    >
                    </Route>
                    {/* <Route path={`*`} element={<ErrorPage props={{error: 404}}/>}></Route> */}
                </Routes>
            )}
        </>
    );
}

export default SiteDefaultPage;
